import React from 'react';

const Loading: React.FC = () => {
  return (
    <div className='loading center'>
      <h2>Loading...</h2>
    </div>
  );
};

export default Loading;
